module.exports = __webpack_public_path__ + "static/media/you-won-mobile.e808755e.png";